import PropTypes from "prop-types";
import React from "react";

import Author from "../Author";

const AutoResponseConfirmationMessage = ({ recognitionRecipient, showChatbotNameAndAvatar }) => (
    <li className="message-container is-bot message-auto-response-confirmation">
        {showChatbotNameAndAvatar && (
            <Author
                authorTitle={i18n.t("rtm.text.chatbot")}
                avatarSrc={recognitionRecipient.avatarSrc}
                name={recognitionRecipient.name}
            />
        )}
        <p className="body">{i18n.t("rtm.text.did_that_answer_your_question")}</p>
    </li>
);

AutoResponseConfirmationMessage.propTypes = {
    recognitionRecipient: PropTypes.object.isRequired,
};

export default AutoResponseConfirmationMessage;
